// extracted by mini-css-extract-plugin
export default {"wrapper":"transactionPeriod_wrapper__XgKu3","subTitle":"transactionPeriod_subTitle__UxFfd","inputWrapper":"transactionPeriod_inputWrapper__iEhFs"};